import { render, staticRenderFns } from "./formularioPromociones.vue?vue&type=template&id=642433e0&scoped=true"
import script from "./formularioPromociones.vue?vue&type=script&lang=js"
export * from "./formularioPromociones.vue?vue&type=script&lang=js"
import style0 from "./formularioPromociones.vue?vue&type=style&index=0&id=642433e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642433e0",
  null
  
)

export default component.exports